import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';

@Component({
  selector: 'lp2-chat-bot-fab',
  animations: [
    trigger('buttonAnimation', [
      transition('void => *', [style({ opacity: 0 }), animate('500ms', style({ opacity: 1 }))]),
      transition('* => void', [animate('500ms', style({ opacity: 0 }))]),
    ]),
  ],
  template: `
    <div class="fab-button-badge" *ngIf="badgeCount">{{ badgeCount }}</div>
    <img src="/images/chat-bot/bot.png" class="fab-button">
  `,
  styleUrls: ['./chat-bot-fab.component.scss'],
  host: {
    class: 'fab-button-container',
    '[attr.tabindex]': '0',
    '[attr.aria-label]': '"Open chat bot"',
    '[attr.role]': '"button"',
    '@buttonAnimation': 'true'
  }
})
export class ChatBotFabComponent {
  @Input() badgeCount: number;
}

@NgModule({
  imports: [CommonModule],
  declarations: [ChatBotFabComponent],
  exports: [ChatBotFabComponent],
})
export class ChatBotFabModule {}



// WEBPACK FOOTER //
// ./ts/app/components/chat-bot-fab/chat-bot-fab.component.ts